import { ApiContentBlock, ApiSectionType } from '@storefronts/common-types'

/** Brand chat runs on a page when any of its inline products turns it on. */
export const hasBrandChatSection = (
    bodyContent: ApiContentBlock | null,
): boolean =>
    (bodyContent?.tabs ?? []).some((tab) =>
        tab.sections.some(
            (section) =>
                section.type === ApiSectionType.INLINE_PDP &&
                section.showBrandChat === true,
        ),
    )
